import { LIVE_DASHBOARD_VITAL_SIGN_THRESHOLDS as THRESHOLDS, LIVE_DASHBOARD_TYPES } from '@/constants/live-dashboard'
import { DataPoint } from '@/jsonapi/CommonTypes'

export function hasConcerningVitalSigns(patientWithLiveData) {
  if (patientWithLiveData.pulseRate && patientWithLiveData.pulseRate.value >= THRESHOLDS.PulseRate) {
    return true
  }
  if (
    patientWithLiveData.oxygenSaturation &&
    patientWithLiveData.oxygenSaturation.value < THRESHOLDS.OxygenSaturation
  ) {
    return true
  }
  if (
    patientWithLiveData.bloodPressureSystolic &&
    patientWithLiveData.bloodPressureSystolic.value >= THRESHOLDS.BloodPressureSystolic
  ) {
    return true
  }
  if (
    patientWithLiveData.bloodPressureDiastolic &&
    patientWithLiveData.bloodPressureDiastolic.value >= THRESHOLDS.BloodPressureDiastolic
  ) {
    return true
  }
  if (patientWithLiveData.bodyTemperature && patientWithLiveData.bodyTemperature.value >= THRESHOLDS.BodyTemperature) {
    return true
  }
  if (patientWithLiveData.bodyWeight && patientWithLiveData.bodyWeight.value >= THRESHOLDS.BodyWeight) {
    return true
  }
  return false
}

export function vitalSignIsConcerning(dataPointType: string, dataPoint: DataPoint): boolean {
  if (!dataPoint) {
    return false
  }
  if (dataPointType === LIVE_DASHBOARD_TYPES.PulseRates) {
    return dataPoint.value >= THRESHOLDS.PulseRate
  }
  if (dataPointType === LIVE_DASHBOARD_TYPES.OxygenSaturations) {
    return dataPoint.value < THRESHOLDS.OxygenSaturation
  }
  if (dataPointType === LIVE_DASHBOARD_TYPES.BloodPressureSystolic) {
    return dataPoint.value >= THRESHOLDS.BloodPressureSystolic
  }
  if (dataPointType === LIVE_DASHBOARD_TYPES.BloodPressureDiastolic) {
    return dataPoint.value >= THRESHOLDS.BloodPressureDiastolic
  }
  if (dataPointType === LIVE_DASHBOARD_TYPES.BodyTemperatures) {
    return dataPoint.value >= THRESHOLDS.BodyTemperature
  }
  if (dataPointType === LIVE_DASHBOARD_TYPES.BodyWeights) {
    return dataPoint.value >= THRESHOLDS.BodyWeight
  }
}
